<!-- Header section -->
<login-header></login-header>

<!-- Stay in touch!-->
<div class="stay_touch gradient_bg" style="background-image: url('/assets/images/contact-bg.webp');">
    <div class="px-90 m-auto">
        <div class="stay_touch_content d-lg-grid">
            <div class="stay_touch_text mb-4">
                <h2 class="lp_h2">Stay in touch!</h2>
                <p class="lp_p">Leave us a message and we’ll be happy to assist you.</p>
            </div>
            <div class="contact_form fc_form">
                <form action="#" [formGroup]="contactMsgForm">
                    <div class="row">
                        <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                                <label for="fname" class="form-label">First name <span class="required">*</span></label>
                                <input type="text" id="fname" class="form-control" maxlength="20" formControlName="firstName" aria-label="first name" required>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                                <label for="lname" class="form-label">Last name <span class="required">*</span></label>
                                <input type="text" id="lname" class="form-control" maxlength="20" formControlName="lastName" aria-label="last name" required>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                                <label for="email" class="form-label">Email address <span class="required">*</span></label>
                                <input type="email" id="email" class="form-control" maxlength="50" formControlName="email" required>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                                <label for="phone" class="form-label">Phone number <span class="required">*</span></label>
                                <app-phone-input [form]="contactMsgForm"></app-phone-input>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="form-group mb-4">
                                <label for="message" class="form-label">Message</label>
                                <textarea name="" rows="5" id="message" class="form-control" formControlName="description" aria-label="type message here"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="form-group submit-btn text-center">
                                <button type="submit" class="border_btn red_border" disableDuringAjax (click)="Send()" aria-label="send">Send</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="contact_hero">
    <div class="px-90 m-auto">
        <div class="contact_content text-center">
            <h1 class="lp_h1 text-capitalize">We’re here for all your questions</h1>
            <p>Contact us Monday - Friday 8 a.m - 5 p.m EST</p>
            <div class="contact_options my-5">
                <ul class="contact_btns d-flex flex-wrap justify-content-center">
                    <li>
                        <a class="btn border rounded-3 p-3" href="mailto:hello&#64;familycentral.com">
                            <img class="mb-2" src="/assets/images/email-circle.svg" width="40" height="40" alt="" loading="lazy">
                            <strong class="d-block">Email</strong>
                            <span class="text_red fw_600">hello&#64;familycentral.com</span>
                        </a>
                    </li>
                    <li>
                        <a class="btn border rounded-3 p-3" href="tel:1-888-780-3264">
                            <img class="mb-2" src="/assets/images/call-circle.svg" width="40" height="40" alt="" loading="lazy">
                            <strong class="d-block">Phone</strong>
                            <span class="text_red fw_600">1-888-780-3264</span>
                        </a>
                    </li>
                    <li>
                        <a class="btn border rounded-3 p-3" routerLink="/book-an-appointment">
                            <img class="mb-2" src="/assets/images/email-circle.svg" width="40" height="40" alt="" loading="lazy">
                            <strong class="d-block">Appointment</strong>
                            <span class="text_red fw_600">Book an appointment</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="ask_anything">
    <div class="px-90 m-auto">
        <div class="ask_anything_top text-center">
            <h2 class="lp_h2 text-capitalize">Ask us anything</h2>
            <p>We are always here to answer your questions.</p>
            <p class="small">Go to our <a routerLink="/faq" class="text_red"><strong>FAQs</strong></a> page.</p>
        </div>
    </div>
</div>

<app-footer></app-footer>
